import type {Origin} from '../../../generated/types';
import {composeDescription, stripMarkup} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

/** Поля предыстории — строки с разметкой и отсылками «(см. главу 6)», которые вне книги не нужны */
function clean(text?: string | null): string {
	return stripMarkup(text)
		.replace(/\s*\(см\.[^)]*\)/g, '')
		.replace(/[.\s]+$/, '');
}

/** «Предыстория Артист. Характеристики: Сила, Ловкость, Харизма. Черта: Музыкант. …» */
export function originDescription(origin: Origin): string {
	const parts = [`Предыстория ${origin.title}.`];
	const add = (label: string, value?: string | null) => {
		const text = clean(value);
		if (text) parts.push(`${label}: ${text}.`);
	};
	add('Характеристики', origin.abilities);
	add('Черта', origin.feat);
	add('Навыки', origin.skills);
	add('Инструменты', origin.instruments);
	return composeDescription(parts.join(' '), origin.description);
}

export function originOgCard(origin: Origin): OgCardData {
	const feat = clean(origin.feat);
	return {
		label: 'Предыстория',
		title: origin.title,
		originalTitle: origin.originalTitle,
		subtitle: [feat && `Черта: ${feat}`, clean(origin.abilities)].filter(Boolean).join(' · '),
	};
}
